var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-config-editor"
  }, [_c('div', {
    staticClass: "mapper-config-editor__toolbar"
  }, [_c('label', {
    staticClass: "mapper-config-editor__mode"
  }, [_c('span', [_vm._v("Mode")]), _c('select', {
    attrs: {
      "disabled": _vm.disabled,
      "data-testid": "mapper-config-mode"
    },
    domProps: {
      "value": _vm.mode
    },
    on: {
      "change": function ($event) {
        return _vm.switchMode($event.target.value);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "json"
    }
  }, [_vm._v("JSON")]), _c('option', {
    attrs: {
      "value": "yaml"
    }
  }, [_vm._v("YAML")])])]), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.disabled,
      "data-testid": "mapper-config-format"
    },
    on: {
      "click": _vm.formatCurrentText
    }
  }, [_vm._v("\n      Format\n    ")]), _c('span', {
    class: ['mapper-config-editor__status', _vm.parseError ? 'is-invalid' : 'is-valid']
  }, [_vm._v("\n      " + _vm._s(_vm.parseError || 'Valid mapper config') + "\n    ")])]), _vm._m(0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.monacoFailed,
      expression: "!monacoFailed"
    }],
    ref: "monacoHost",
    staticClass: "mapper-config-editor__monaco"
  }), _vm.monacoFailed ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.text,
      expression: "text"
    }],
    staticClass: "mapper-config-editor__fallback",
    attrs: {
      "readonly": _vm.disabled,
      "disabled": _vm.disabled,
      "data-testid": "mapper-config-text"
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.text = $event.target.value;
      }, _vm.emitParsedValue]
    }
  }) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-config-editor__guide"
  }, [_c('strong', [_vm._v("Mapper DSL quick guide")]), _c('ul', [_c('li', [_c('code', [_vm._v("{ \"path\": \"payload.temperature\" }")]), _vm._v("\n        reads a value from the incoming JSON packet.\n      ")]), _c('li', [_vm._v("\n        Use a literal value like\n        "), _c('code', [_vm._v("\"battery\"")]), _vm._v("\n        or\n        "), _c('code', [_vm._v("1001")]), _vm._v("\n        to write a fixed value.\n      ")]), _c('li', [_c('code', [_vm._v("{ \"capture\": \"device\" }")]), _vm._v("\n        reads a value captured by\n        "), _c('code', [_vm._v("input.topicPattern")])]), _c('li', [_c('code', [_vm._v("{ \"lookup\": { \"table\": \"deviceToTwin\", \"from\": { \"path\": \"deviceId\" } } }")]), _vm._v("\n        maps an input value through\n        "), _c('code', [_vm._v("lookups.deviceToTwin")])]), _c('li', [_c('code', [_vm._v("transforms")]), _vm._v("\n        can convert values with\n        "), _c('code', [_vm._v("number, string, boolean, timestampIso, multiply, divide, scalePow10, default")])])])]);
}];
export { render, staticRenderFns };